export default __webpack_public_path__ + "static/media/Cosmetic-Dentistry.2991a168.png";